import React from "react";
import "./ProductSlider.css";
import Slider from "react-slick";
import product1 from "../Assests/img40.jpeg";
import product2 from "../Assests/img41.jpeg";
import product3 from "../Assests/img35.jpeg";
import product4 from "../Assests/img47.jpg";
import product5 from "../Assests/img46.jpg";
import product6 from "../Assests/img43.jpeg";
import product7 from "../Assests/img45.jpeg";

// Dummy data for slider
const sliderData = [
  {
    id: 1,
   
    image: product1,
    heading: "Surgical Consumables",
    description:
      "Surgical consumables ensure safe procedures with sterile gloves, masks, sutures, and dressings, supporting quality patient care.",
    signature: "SurgicalCare+ ✨",
  },
  {
    id: 2,
    
    image: product2,
    heading: "Medical Consumables",
    description:
      "Medical consumables, including gloves, syringes, and dressings, are essential for infection control and effective patient care in healthcare settings.",
    signature: "SafeHands  🏜",
  },
  {
    id: 3,
    
    image: product3,
    heading: "Nutraceuticals",
    description:
      "Nutraceuticals combine nutrition and pharmaceuticals, offering health benefits through supplements, functional foods, and fortified products to support overall well-being.",
    signature: "SterileTouch  ❤️",
  },
  {
    id: 4,
    
    image: product4,
    heading: "Branded Ethical Drugs",
    description:
      "Branded ethical drugs ensure high-quality, doctor-prescribed medications that meet strict safety and efficacy standards for patient care.",
    signature: "CareSterile  💊",
  },
  {
    id: 5,
    
    image: product5,
    heading: "Branded Generic Drugs",
    description:
      "Branded generic drugs offer cost-effective alternatives to branded medicines while maintaining the same quality, safety, and effectiveness.",
    signature: "VitalGlove 🩹",
  },
  {
    id: 6,
    
    image: product6,
    heading: "Implants ",
    description:
      "Implants, such as orthopedic and dental devices, provide long-term support and restoration, enhancing patient mobility and quality of life.",
    signature: "PrecisionMed 🩺",
  },
  {
    id: 7,
    
    image: product7,
    heading: "Injectables ",
    description:
      "Injectables ensure precise medication delivery, including vaccines, antibiotics, and pain management, for fast and effective patient treatment.",
    signature: "MedShield 💉",
  },
];

const ProductSlider = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 1500,
    slidesToShow: 2, // Only 1 slide visible at a time
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  return (
    <div className="slider-container">
    <h1 className="slider-header">Our Service Product</h1>
      <Slider {...settings}>
        {sliderData.map((item) => (
          
          <div className="hero-container">
          
            <div className="hero-image-wrapper">
              <div className="hero-image-background"></div>{" "}
              <img src={item.image} alt="Profile" className="hero-image" />
              {/* Vertical Signature */}
              <p className="hero-signature">{item.signature}</p>
            </div>
            <h1 className="hero-heading">{item.heading}</h1>
            <p className="hero-description">{item.description}</p>
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default ProductSlider;
